import FileCard from './FileCard'

export default FileCard
